// extracted by mini-css-extract-plugin
export default {"pageNotFoundContainer":"PageNotFound_pageNotFoundContainer__emrm6","back-button":"PageNotFound_back-button__o93yw"};